import "../../assets/scss/components/pagination.scss";
export const Pagination: React.FC<any> = (props) => {
    const {
        pagination={},
        handlePage
    } = props;

    return (<>
        {pagination.pages > 1 && (
            <div className={(props.className?props.className+" ":"")+"pagination-warapper d-flex justify-content-end w-100 mb-4"}>
                {pagination.pages>10?(
                    <>
                    {/* prev */}
                    <div onClick={()=>handlePage(pagination.page-1)} className={"pagination-cell dir-btn"+(pagination.page===0?" de-active":" focus")}><img src="imgs/pagination-prev.svg" alt=""/></div>
                    {/* 1 */}
                    {pagination.page>0&&(<div onClick={()=>handlePage(0)} className="pagination-cell focus">{1}</div>)}
                    {/* 2 */}
                    {pagination.page>1&&(<div onClick={()=>handlePage(1)} className="pagination-cell focus">{2}</div>)}
                    {/* ... */}
                    {pagination.page>2&&(<div className="pagination-cell dot">...</div>)}
                    {/* current */}
                    <div className="pagination-cell active">{pagination.page+1}</div>
                    {/* ... */}
                    {pagination.page<pagination.pages-2&&(<div className="pagination-cell dot">...</div>)}
                    {/* last-1 */}
                    {pagination.page<pagination.pages-2&&(<div onClick={()=>handlePage(pagination.pages-2)} className="pagination-cell focus">{pagination.pages-1}</div>)}
                    {/* last */}
                    {pagination.page<pagination.pages-1&&(<div onClick={()=>handlePage(pagination.pages-1)} className="pagination-cell focus">{pagination.pages}</div>)}
                    {/* next */}
                    <div onClick={()=>handlePage(pagination.page+1)} className={"pagination-cell dir-btn"+(pagination.page===pagination.pages-1?" de-active":" focus")}><img src="imgs/pagination-next.svg" alt=""/></div>
                    </>
                ):(
                    <>
                    {Array(pagination.pages).fill("0")?.map((m:any,index: number)=>(
                        <div key={index} className={"pagination-cell focus"+(pagination.page===index?' active':'')} onClick={()=>handlePage(index)}>{index+1}</div>
                    ))}
                    </>
                )}
                
            </div>
        )}
    </>);
};